import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NouisliderComponent } from 'ng2-nouislider';
import { FilingsService } from '../../filings.service';

@Component({
  selector: 'app-slider-price',
  templateUrl: './sliderPrice.component.html',
  styleUrls: ['./sliderPrice.component.scss']
})
export class SliderPriceComponent implements OnInit, OnDestroy {
  @ViewChild('slider') slider: NouisliderComponent;
  divider = '-';
  config: any = {
    behaviour: 'drag',
    connect: true,
    snap: true,
    range: {
      min: 0,
      '20%': 1,
      '40%': 5,
      '60%': 10,
      '80%': 100,
      max: 1000000
    },
  };
  modelRange = [0, 1000000]; // 1000000 means 100+
  range = ['0', '100+'];

  constructor(private filingsService: FilingsService) { }

  ngOnInit() {
    this.onChange();
  }

  onChange(e?) {
    if (!this.slider) {
      return;
    }
    // tslint:disable-next-line: no-string-literal
    const prevRange = this.slider['__ngSimpleChanges__'].previous.ngModel.currentValue;
    this.range[0] = this.modelRange[0].toString();
    this.range[1] = this.modelRange[1].toString();

    if (this.modelRange[1] === 1000000) {
      this.range[1] = '100+';
    }
    if (this.modelRange[0] === 1000000 && this.modelRange[1] === 1000000) {
      this.range[0] = '100+';
      this.range[1] = '';
      this.divider = '';
    } else {
      this.divider = '-';
    }
    if (this.modelRange[0] === this.modelRange[1]) {
      if (prevRange[0] !== this.modelRange[0]) { // handle 0 moved, jump back
        this.slider.slider.set([prevRange[0], this.modelRange[1]]);
      }
      if (prevRange[1] !== this.modelRange[1]) { // handle 1 moved, jump back
        this.slider.slider.set([this.modelRange[0], prevRange[1]]);
      }
    }
    this.filingsService.onPriceSliderChanged(this.modelRange);

  }

  ngOnDestroy() {

  }
}
